import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import EpiContext from '@episerver/spa-core/Spa';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import gaParams from '../../../utilities/analytics/constants';
import {gaEvent} from '../../../utilities/analytics/tracking';
import authenticationProvider from '../../../utilities/authentication/authenticationProvider';
import {getActionsByTypes} from '../CoreProductActionsBlock/CoreProductActionsSlice';
import {prepareBlockAsync, reportDWH} from './SelfCareInvoiceBlockSlice';
import {activeInvoiceOnlineIFrame} from '../PersonalAreaInvoicesBlock/invoiceComponentBlockSlice';
import SingleInvoice from './Partials/SingleInvoice';
import NoInvoicesNewCustomer from './Partials/InvoiceErrorMessages/NoInvoicesNewCustomer';
import NoInvoicesOldCustomer from './Partials/InvoiceErrorMessages/NoInvoicesOldCustomer';
import DisplayInvoicesError from './Partials/InvoiceErrorMessages/DisplayInvoicesError';
import CarouselInvoices from './Partials/CarouselInvoices';
import InvoiceLoginRedirect from './Partials/InvoiceLoginRedirect';
import Skeleton from 'react-loading-skeleton';
import {buildUrlAndOpenWindow} from '../../../utilities/StringHelpers/StringHelpers';
import Popup from '../../Shared/Popup/PopUp';
import IdValidationPopup from '../OTPLoginBlock/Popups/idValidationPopup';

const SelfCareInvoicesMain = (props) => {
  let {invoicesList, loading, error, invoiceData, loginType} = props.data;
  const {isFullAuthenticated, isOtpExtendedAuthenticated} = props.authentication.loginData;

  let invoicesOldPageUrl = props.iContent?.invoicesPageUrl?.value;
  let billCycle = invoiceData.billCycle;
  let invoiceOnlineIFrameURL = props.iContent?.invoiceOnlineIFrameURL?.value; //New Invoice Page URL from Episerver
  let isStandalone = props.iContent?.isStandalone?.value;

  const [showIDPopup, setShowIDPopUp] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState('');
  const [invoiceId, setInvoiceId] = useState('');

  let currentView = (
    <div className='invoices-skeleton-wrapper'>
      <Skeleton className='skeleton' />
    </div>
  );

  const setSessionStorage = (banPsid, invoiceSourceType, id) => {
    const data = {
      banPsid: banPsid,
      invoiceSourceType: invoiceSourceType,
      id: id,
    };
    sessionStorage.setItem('invoiceIframeData', JSON.stringify(data));
  };

  const openInvoiceIframe = async (billUrl, invoiceSourceType, banPsid, id) => {
    props.reportDWH({actionType: `MyZone ${props.worldType}`, status: 'Ongoing', messageText: 'MyZone Invoice Clicked', param1: banPsid});
    setInvoiceId(id);

    if (isOtpExtendedAuthenticated && !(props.authentication?.loginData?.userDetails?.role & 128)) {
      setSessionStorage(banPsid, invoiceSourceType, id);
      authenticationProvider.redirectToLogin(invoiceOnlineIFrameURL, '');
    } else if (isOtpExtendedAuthenticated && props.authentication?.loginData?.userDetails?.role & 128) {
      setSessionStorage(banPsid, invoiceSourceType, id);
      setRedirectUrl(invoiceOnlineIFrameURL);
      setShowIDPopUp(true);
    } else if (isFullAuthenticated) {
      setSessionStorage(banPsid, invoiceSourceType, id);
      EpiContext.navigateTo(invoiceOnlineIFrameURL);
    }
  };

  const closeModalIdPopup = () => {
    EpiContext.navigateTo(redirectUrl);
    setShowIDPopUp(false);
  };

  const openOldInvoicesPage = async () => {
    if (isFullAuthenticated) {
      buildUrlAndOpenWindow(invoicesOldPageUrl);
    } else if (isOtpExtendedAuthenticated && props.authentication?.loginData?.userDetails?.role & 128) {
      setRedirectUrl(invoicesOldPageUrl);
      setShowIDPopUp(true);
    } else if (isOtpExtendedAuthenticated && !(props.authentication?.loginData?.userDetails?.role & 128)) {
      authenticationProvider.redirectToLogin(invoicesOldPageUrl, '');
    }
  };

  useEffect(() => {
    if ((props.isFetchData || isStandalone) && props.authentication.isAuthenticateFinish) {
      props.prepareBlockAsync();
    }
  }, [props.isFetchData, props.authentication.isAuthenticateFinish]);

  useEffect(() => {
    if (!loading && !error)
      gaEvent(
        gaParams.SELF_CARE_INVOICES_BLOCK_LOADED.category,
        gaParams.SELF_CARE_INVOICES_BLOCK_LOADED.eventType,
        props.data.invoicesList.length,
      );
  }, [loading]);

  switch (props.page) {
    case 'displayInvoicesError':
      currentView = <DisplayInvoicesError />;
      break;
    case 'noInvoicesNewCustomer':
      currentView = <NoInvoicesNewCustomer billCycle={billCycle} />;
      break;
    case 'noInvoicesOldCustomer':
      currentView = <NoInvoicesOldCustomer />;
      break;
    case 'singleInvoice':
      currentView = (
        <SingleInvoice
          data={invoicesList}
          loginType={loginType}
          invoicesOldPageUrl={invoicesOldPageUrl}
          openInvoiceIframe={openInvoiceIframe}
          openOldInvoicesPage={openOldInvoicesPage}
        />
      );
      break;
    case 'carouselInvoices':
      currentView = (
        <CarouselInvoices
          data={invoicesList}
          loginType={loginType}
          invoicesOldPageUrl={invoicesOldPageUrl}
          openInvoiceIframe={openInvoiceIframe}
          openOldInvoicesPage={openOldInvoicesPage}
        />
      );
      break;
    case 'invoiceLoginRedirect':
      currentView = <InvoiceLoginRedirect />;
      break;
  }

  return (
    <div>
      <div className='mainTitle'>{props.iContent?.mainTitle?.value}</div>
      {currentView}
      <Popup showPopUp={showIDPopup} onClose={() => setShowIDPopUp(false)} style={{background: 'white'}}>
        <IdValidationPopup setShowPopUp={setShowIDPopUp} closeModal={closeModalIdPopup} />
      </Popup>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    page: state.selfCareInvoiceBlock.page,
    data: state.selfCareInvoiceBlock,
    authentication: state.authentication,
    isFetchData: state.selfcarePage?.isFetchData,
    worldType: state.selfcarePage.epiData.worldType,
  };
};
const mapDispatchToProps = {
  showAppLoader,
  hideAppLoader,
  prepareBlockAsync,
  getActionsByTypes,
  activeInvoiceOnlineIFrame,
  reportDWH,
};
export default connect(mapStateToProps, mapDispatchToProps)(SelfCareInvoicesMain);
